import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'numberComma',
  pure: false, // TranslateService dil değişikliğini algılaması için pure false olmalı
})
export class NumberCommaFormatPipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  transform(value: any, decimalPlaces: number = 2): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    // String olarak gelen değerleri sayıya çevirmeyi dene
    let numericValue = typeof value === 'number' ? value : Number(
      (value as string).toString().replace(',', '.')
    );

    // Hala geçerli bir sayı değilse bilgi mesajı dön
    if (Number.isNaN(numericValue)) {
      return `${value} ${this.translateService.instant('common.not-number-type')}`;
    }

    const lang = this.translateService.currentLang || this.translateService.getDefaultLang() || 'tr';

    // Kısa dil kodunu tam bölgesel ayara dönüştür
    const locale = this.mapLanguageToLocale(lang);

    // Sayıyı istenen ondalık basamakla formatla
    const formattedValue = new Intl.NumberFormat(locale, {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }).format(numericValue);

    return formattedValue;
  }

  private mapLanguageToLocale(lang: string): string {
    const localeMap: { [key: string]: string } = {
      tr: 'tr-TR',
      en: 'en-US',
      de: 'de-DE',
      fr: 'fr-FR',
    };
    return localeMap[lang] || 'en-US';
  }
}
